module.exports = __webpack_public_path__ + "img/6-1_06.02a86575.jpg";